import React, {Component} from 'react';
import Modal from "react-bootstrap/Modal";
import Aboutus from './Aboutus';
import Terms from './Terms';
import Signup from './Signup';
import axios from 'axios';

class Footer extends Component {
	constructor(props){
		super(props);

		this.state = {
			showAboutPopup: false,
			showTermsPopup: false,
			contactUserEmail: '',
			contactUserMessage: '',
			contactUserEmailError: false,
			contactUserMessageError: false,
			signupUserEmail: '',
			signupEmailError: false,
			showSignupPopup: false
		}

		this.submitSignUp = this.submitSignUp.bind(this);
	}

	componentDidMount() {
		if (window.location.search == "?privacy_policy") {
			this.setState({
				showTermsPopup: true
			})
		}
	}

	showAboutPopup(e) {
		e.preventDefault();
		this.toggleAboutPopup();
	}

	toggleAboutPopup() {
		this.setState({
			showAboutPopup: !this.state.showAboutPopup
		})
	}

	showTermsPopup(e) {
		e.preventDefault();
		this.toggleTermsPopup();
	}

	toggleTermsPopup() {
		this.setState({
			showTermsPopup: !this.state.showTermsPopup
		})
	}

	changeContactUserEmail(e) {
		this.setState({
			contactUserEmailError: false,
			contactUserEmail: e.target.value
		});
	}

	changeContactMessage(e) {
		this.setState({
			contactUserMessageError: false,
			contactUserMessage: e.target.value
		});
	}

	submitContact(e) {
		e.preventDefault();

		const expression = /(?!.*\.{2})^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([\t]*\r\n)?[\t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([\t]*\r\n)?[\t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;
		var checkEmail = expression.test(String(this.state.contactUserEmail).toLowerCase());
		if ( checkEmail && this.state.contactUserMessage ) {
			const data = {
				contactUserEmail: this.state.contactUserEmail,
				contactUserMessage: this.state.contactUserMessage
			}

			this.setState({
				contactUserEmail: '',
				contactUserMessage: ''
			})

			axios.defaults.withCredentials = true;

			axios.post(window.$backend_url + '/contactEmail', data)
				.then(response => {
					
				})
				.catch(error => {
					
				})
		} else if (!checkEmail) {
			this.setState({
				contactUserEmailError: true
			})
		} else {
			this.setState({
				contactUserMessageError: true
			})
		}
	}

	changeSignUpUserEmail(e) {
		this.setState({
			signupUserEmail: e.target.value,
			signupEmailError: false
		});
	}

	submitSignUp(e) {
		e.preventDefault();

		const expression = /(?!.*\.{2})^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([\t]*\r\n)?[\t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([\t]*\r\n)?[\t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;
		if ( expression.test(String(this.state.signupUserEmail).toLowerCase()) ) {
			this.props.header.showSignUpForUpdatePopup(this.state.signupUserEmail);

			this.setState({
				signupUserEmail: ''
			})
		} else {
			this.setState({
				signupEmailError: true
			})
		}
	}

	render() {
		return (
			<div>
				<footer>
					<div className="container">
						<div className="left-footer">
							<div className="company">
								<h3>{this.props.dataLanguage['company']}</h3>
								<ul>
									<li><a href="" onClick={this.showAboutPopup.bind(this)}>{this.props.dataLanguage['aboutUs']}</a></li>
									<li><a href="" onClick={this.showTermsPopup.bind(this)}>{this.props.dataLanguage['tos']} & {this.props.dataLanguage['copyright']}</a></li>
								</ul>
							</div>
							<div className="social">
								<h3>{this.props.dataLanguage['socialMedia']}</h3>
								<ul>
									<li><a href="https://www.facebook.com/DigitXchange-107227027571209/?modal=admin_todo_tour" target="_blank" rel="noopener noreferrer"><img alt="" src="/assets/images/icons/facebook.png" /></a></li>
									<li><a href="https://twitter.com/DigitXchange" target="_blank" rel="noopener noreferrer"><img alt="" src="/assets/images/icons/twitter.png" /></a></li>
									<li><a href="https://www.instagram.com/digitxchange/?hl=en" target="_blank" rel="noopener noreferrer"><img alt="" src="/assets/images/icons/insta.png" /></a></li>
								</ul>
							</div>
							<div className="sign-up">
								<h3>{this.props.dataLanguage['signupForUpdates']}</h3>
								<form>
									<input className={ this.state.signupEmailError ? 'error' : '' } name="mail" type="email" placeholder={this.props.dataLanguage['emailAddr']} value={this.state.signupUserEmail} onChange={this.changeSignUpUserEmail.bind(this)} />
									<input type="submit" value={this.props.dataLanguage['signup']} onClick={this.submitSignUp.bind(this)} />
								</form>
								<p>{this.props.dataLanguage['footer_msg_1']} <a href="" onClick={this.showTermsPopup.bind(this)}>{this.props.dataLanguage['terms']} {this.props.dataLanguage['and']} {this.props.dataLanguage['privacy_policy']}</a>.</p>
							</div>
						</div>
						<div className="right-footer">
							<h3>{this.props.dataLanguage['contactUs']}</h3>
							<form>
								<label>{this.props.dataLanguage['yourEmail']} ({this.props.dataLanguage['required']})</label>
								<input name="mail" type="email" value={this.state.contactUserEmail} onChange={this.changeContactUserEmail.bind(this)} />
								{ this.state.contactUserEmailError ?
									<p className="text-error">{ this.props.dataLanguage['email_required'] }</p>
								: null}
								<label>{this.props.dataLanguage['yourMsg']}</label>
								<textarea value={this.state.contactUserMessage} onChange={this.changeContactMessage.bind(this)}></textarea>
								{ this.state.contactUserMessageError ?
									<p className="text-error">{ this.props.dataLanguage['message_required'] }</p>
								: null}
								<button onClick={this.submitContact.bind(this)}>{this.props.dataLanguage['sent']}</button>
							</form>
						</div>
					</div>
					<div className="container">
						<div className="Copyright-btm">
							<p>&copy; 2019 DigitXchange, Inc. {this.props.dataLanguage['footer_msg_2']}. {this.props.dataLanguage['footer_msg_3']}.</p>
						</div>
					</div>
				</footer>
				{this.state.showAboutPopup ?  
					<Modal show={this.state.showAboutPopup} onHide={this.toggleAboutPopup.bind(this)} animation={false} className="">
						<Modal.Header closeButton>
						</Modal.Header>
						<Aboutus dataLanguage={this.props.dataLanguage} />
					</Modal>
				: null
				}
				{this.state.showTermsPopup ?  
					<Modal show={this.state.showTermsPopup} onHide={this.toggleTermsPopup.bind(this)} animation={false} className="largeModal">
						<Modal.Header closeButton>
						</Modal.Header>
						<Terms dataLanguage={this.props.dataLanguage} />
					</Modal>
				: null
				}
			</div>
		);
	}
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js